module.exports = __webpack_public_path__ + "site/img/140.aefa1a52.jpg";